import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'checkbox-standalone-wrapper',
  templateUrl: './checkbox-standalone-wrapper.component.html',
  styleUrls: ['./checkbox-standalone-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxStandaloneWrapperComponent extends FieldWrapper {}
